var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconNavUp = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 7.8",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.77,6.44,7.56.23a.8.8,0,0,0-1.13,0L.23,6.43A.8.8,0,0,0,1.37,7.56L7,1.93l5.63,5.64a.81.81,0,0,0,1.14,0A.8.8,0,0,0,13.77,6.44Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNavUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-nav-up.0fd29be7.svg";
export { ForwardRef as ReactComponent };